import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { DeviceType } from '../../interfaces/api/deviceType';
import { fetchDeviceTypes } from '../services/deviceTypes.service';
import { DeviceTypeFilterParams } from '../../api/deviceTypes';

interface DeviceTypeState {
	deviceTypes: {
		byId: Record<number, DeviceType>;
		all: DeviceType[];
	};
	isLoading: boolean;
}

const initialState = {
	deviceTypes: {
		byId: {},
		all: [],
	},
	isLoading: false,
} as DeviceTypeState;

export const fetchDeviceTypesThunk = createAsyncThunk<
	DeviceType[],
	{ params: DeviceTypeFilterParams }
>('deviceType/fetchDeviceTypes', async ({ params }, { rejectWithValue }) => {
	try {
		return await fetchDeviceTypes(params);
	} catch (error) {
		return rejectWithValue(error);
	}
});

const deviceTypeSlice = createSlice({
	name: 'deviceType',
	initialState,
	reducers: {
		resetDeviceType: (state) => {
			Object.assign(state, initialState);
		},
	},
	extraReducers: (builder) => {
		builder.addCase(fetchDeviceTypesThunk.fulfilled, (state, action) => {
			const byId: Record<number, DeviceType> = {};
			action.payload.forEach((deviceType) => {
				byId[deviceType.id] = deviceType;
			});
			const all = action.payload.map((deviceType) => deviceType);
			state.deviceTypes = { byId, all };
			state.isLoading = false;
		});
		builder.addCase(fetchDeviceTypesThunk.pending, (state) => {
			state.isLoading = true;
		});
		builder.addCase(fetchDeviceTypesThunk.rejected, (state, action) => {
			state.deviceTypes = {
				byId: {},
				all: [],
			};
			state.isLoading = false;
		});
	},
});

export const { resetDeviceType } = deviceTypeSlice.actions;

export default deviceTypeSlice;
